import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserAvatarService {
    private _labelBgColor: string;
    private _labelTextColor: string;

    get labelBgColor(): string {
        return this._labelBgColor || this.defaultLabelBgColor;
    }

    set labelBgColor(value: string) {
        this._labelBgColor = value;
    }

    get labelTextColor(): string {
        return this._labelTextColor || this.defaultLabelTextColor;
    }

    set labelTextColor(value: string) {
        this._labelTextColor = value;
    }

    private defaultLabelBgColor = '#fed030';
    private defaultLabelTextColor = '#000000';
}
